import React from 'react'
import Reflux from "reflux";
import api from "../../source/api";

export default class DownloadFile extends Reflux.Component {

    render() {
        return (
            <a
                className={this.props.class || 'green-btn uppercase mr-2'}
                onClick={(type) => api.downloadFile(this.props.url, this.props.name)}
            >
                {this.props.title}
            </a>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/common/DownloadFile.js